import { Collapsible } from "../../components/Collapsible";
import { Badge } from "../../components/ui";

/** Attendus de l'évaluateur d'un incident (incidents « drones » de la DIREX) : bloc repliable, liste à puces, nombre
 *  d'attendus à droite du titre. Réservés à la direction de l'exercice (animateur, observateur, 3A) : le serveur n'en
 *  envoie jamais à la cellule entraînée ; rien ne s'affiche pour un incident qui n'en a pas. */
export function ExpectedActions({ items, title, defaultOpen = false }: { items?: string[]; title: string; defaultOpen?: boolean }) {
  if (!items?.length) return null;
  return (
    <Collapsible title={title} trailing={<Badge>{items.length}</Badge>} defaultOpen={defaultOpen}>
      <ul className="list-disc space-y-1 pl-4 text-ui leading-relaxed text-ink" data-expected-actions>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </Collapsible>
  );
}
